const API_URL = process.env.REACT_APP_STORE_LINKS_API;

export async function fetchStoreLinks() {
  const res = await fetch(API_URL);
  if (!res.ok) {
    throw new Error(`Store links API failed: ${res.status}`);
  }
  const data = await res.json();
  console.log({data})
  return {
    android: data.data.link_download_android_chplay.value,
    ios: data.data.link_download_ios_store.value,
  };
}
